function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, G, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(Rect, {
  fill: "#00245A",
  width: 61,
  height: 61,
  rx: 10
});

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M26.858 20h19.895v1.944H26.858zm0 6.004h19.895v1.944H26.858zm0 6.004h19.895v1.944H26.858zm0 6.605h19.895v1.944H26.858z",
  fill: "#17bf88"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#17bf88",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement(Path, {
  d: "M20 23.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M22 30c0-2.209-2.015-4-4.5-4-2.486 0-4.5 1.791-4.5 4"
})));

function SvgIconViewMosaicLeft(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61
  }, props), _ref, _ref2);
}

export default SvgIconViewMosaicLeft;